<template>
  <div class="export-form">
    <div class="form-section">
      <div class="flex w-4/5 mx-auto gap-x-8 justify-center">
        <div class="flex-1 max-w-md">
          <h4 class="text-center mb-6">Export des pré-chiffrages</h4>
          
          <div class="mb-6">
            <label for="select-year" class="block text-sm font-semibold text-darkblue uppercase mb-2">Année</label>
            <div class="select is-medium">
              <div class="relative">
                <select 
                  id="select-year" 
                  v-model="preChiffrageYear"
                  class=""
                >
                  <option 
                    v-for="year in availableYears" 
                    :key="year"
                    :value="year"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-section submit-section mt-8">
            <VButton 
              class="px-8 py-4 text-lg w-full" 
              type="button" 
              :disabled="exportingPreChiffrage"
              @click="handleExportPreChiffrage"
            >
              <i v-if="exportingPreChiffrage" class="ico loading" />
              <i v-else class="ico export" />
              Exporter
            </VButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { VButton } from '../../components/Widget'
import api from '../../services/api'

export default {
  name: 'ExportPreChiffragesView',
  components: {
    VButton
  },
  setup() {
    const preChiffrageYear = ref(new Date().getFullYear())
    const exportingPreChiffrage = ref(false)
    const availableYears = ref([])
    
    // Générer la liste des années disponibles (5 dernières années + année en cours + 2 années futures)
    const generateAvailableYears = () => {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = currentYear - 5; i <= currentYear + 2; i++) {
        years.push(i)
      }
      return years.reverse() // Trier du plus récent au plus ancien
    }
    
    // Export des pré-chiffrages
    const handleExportPreChiffrage = async () => {
      // Empêcher les doubles clics
      if (exportingPreChiffrage.value) {
        console.warn('Export déjà en cours, veuillez patienter...')
        return
      }
      
      exportingPreChiffrage.value = true
      
      try {
        // Importer authService pour faire une requête authentifiée
        const authService = (await import('../../services/authService')).default
        
        // Construire l'URL correcte (avec le "s" à pre-chiffrages)
        const exportUrl = `${api.baseURL}/pre-chiffrages/export/${preChiffrageYear.value}`
        
        
        // Faire la requête de téléchargement
        const response = await authService.makeAuthenticatedRequest(exportUrl)
        
        if (!response.ok) {
          // Si c'est une erreur 404, afficher un message personnalisé
          if (response.status === 404) {
            const errorData = await response.json().catch(() => ({}))
            alert(errorData.error || `Aucun pré-chiffrage trouvé pour l'année ${preChiffrageYear.value}`)
            return
          }
          
          throw new Error(`Erreur lors du téléchargement: ${response.status}`)
        }
        
        // Récupérer le blob du fichier Excel
        const blob = await response.blob()
        
        // Créer un lien de téléchargement
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `pre-chiffrages-${preChiffrageYear.value}-${new Date().toISOString().split('T')[0]}.xlsx`
        document.body.appendChild(link)
        link.click()
        
        // Nettoyer
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
        
        
      } catch (error) {
        console.error('Erreur lors de l\'export des pré-chiffrages:', error)
        alert('Erreur lors de l\'export des pré-chiffrages. Veuillez réessayer.')
      } finally {
        exportingPreChiffrage.value = false
      }
    }
    
    // Charger les données au montage du composant
    onMounted(() => {
      availableYears.value = generateAvailableYears()
    })
    
    return {
      preChiffrageYear,
      exportingPreChiffrage,
      availableYears,
      handleExportPreChiffrage
    }
  }
}
</script>

<style lang="scss" scoped>
@import './Export.scss';
</style>
